import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=fb2f3032&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2f3032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2f3032')) {
      api.createRecord('fb2f3032', component.options)
    } else {
      api.reload('fb2f3032', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=fb2f3032&scoped=true&", function () {
      api.rerender('fb2f3032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gHJK6fe5quJ3/JS/comp/Voucher-Unit.vue"
export default component.exports